<template>
    <v-container
        class="white pa-0 pb-10 ma-0"
    >
        <v-card
            class="mt-0"
            flat
        >
            <v-row
                class="grey lighten-3 mb-3"
                no-gutters
            >
                <v-card-title
                    class="headline ml-3"
                    primary-title
                >
                    Add Ingredient
                </v-card-title>
                <v-btn
                    absolute
                    small
                    fab
                    class="mr-3 text-right"
                    style="top: 10px; right: 10px;"
                    @click.prevent="cancelCreateNewIngredient"
                >
                    <v-icon>
                        close
                    </v-icon>
                </v-btn>
            </v-row>

            <!------------------------------------->
            <!--     adding to recipe inputs     -->
            <!------------------------------------->
            <!-- ========================================== MAKE SURE THIS SECTION WORKS FOR RECIPE VIEW ========================================== -->
            <v-row
                v-if="currentRoute == 'recipes'"
                align="center"
                no-gutters
            >
                <v-col>
                    <v-autocomplete
                        id="ingredient"
                        v-model="ingredientToAdd"
                        label="Ingredient"
                        :items="ingredient"
                        hide-details
                        v-on:input="newIngredientUpdated"
                        @keydown.enter="saveIngredient"
                        @keydown.esc="cancelAddIngredient"
                    ></v-autocomplete>
                </v-col>
                <v-col
                    class="shrink ml-2"
                >
                    <v-btn
                        v-if="!createNewIngredientBoolean"
                        fab
                        x-small
                        @click.prevent="createNewIngredient"
                        color="#74cf74"
                    >
                        <v-icon
                            color="#ffffff"
                            medium
                        >
                            add
                        </v-icon>
                    </v-btn>
                    <v-btn
                        v-if="createNewIngredientBoolean"
                        fab
                        x-small
                        @click.prevent="cancelCreateNewIngredient"
                        color=error
                    >
                        <v-icon
                            color="#ffffff"
                            medium
                        >
                            close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <!------------------------------------>
            <!-- standard add ingredient inputs -->
            <!------------------------------------>
            <v-row
                class="px-5"
                no-gutters
            >
                <v-col>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td colspan="2" class="black"/>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-text-field
                                                v-model="newIngredientName"
                                                label="New Ingredient Name"
                                                hide-details
                                                height="30"
                                                @keydown.enter="saveNewIngredient"
                                                @keydown.esc="cancelCreateNewIngredient"
                                            ></v-text-field>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-autocomplete
                                                v-model="storeSection"
                                                label="Section in Store"
                                                :items="storeSections"
                                                hide-details
                                                height="30"
                                                @keydown.enter="saveNewIngredient"
                                                @keydown.esc="cancelCreateNewIngredient"
                                            ></v-autocomplete>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-row
                                            no-gutters
                                        >
                                            <v-col
                                                cols="4"
                                                class="mb-1 pr-2"
                                            >
                                                <v-text-field
                                                    v-model="newIngredientUnitQuantity"
                                                    label="Quantity"
                                                    type="number"
                                                    hide-details
                                                    height="30"
                                                    @keydown.enter="saveNewIngredient"
                                                    @keydown.esc="cancelCreateNewIngredient"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                class="mb-1 pl-2"
                                            >
                                                <v-select
                                                    v-model="newIngredientUnit"
                                                    :items="unitOptionsNew"
                                                    label="Units"
                                                    hide-details
                                                    height="30"
                                                    @keydown.enter="saveNewIngredient"
                                                    @keydown.esc="cancelCreateNewIngredient"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                    </td>
                                </tr>
                                <tr
                                    v-if="newIngredientUnit == 'count'"
                                >
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-text-field
                                                v-model="newIngredientPlural"
                                                label="New Ingredient Name (Plural)"
                                                hide-details
                                                height="30"
                                                @keydown.enter="saveNewIngredient"
                                                @keydown.esc="cancelCreateNewIngredient"
                                            ></v-text-field>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <v-col
                                            class="mb-1 pa-0"
                                        >
                                            <v-autocomplete
                                                v-model="allergy"
                                                :items="allergy.includes('none',0) ? ['none'] : allergies"
                                                item-text="name"
                                                item-value="id"
                                                label="Allergies"
                                                item-color="#32a852"
                                                hide-details
                                                multiple
                                                height="40"
                                            >
                                                <template
                                                    v-slot:selection="{ item, index }"
                                                >
                                                    <v-chip
                                                        v-if="index < 4"
                                                    >
                                                        <span>
                                                            {{ item.name }}
                                                        </span>
                                                    </v-chip>
                                                    <span
                                                        v-if="index === 4"
                                                        class="grey--text caption"
                                                    >
                                                        (+{{ allergy.length - 4 }} more)
                                                    </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="black"/>
                                </tr>
                                <tr v-for="item in nutrition" :key="item.category">
                                    <td><div :class="[item.ml, item.fontWeight]"> {{item.category}} </div></td>
                                    <td
                                        class="text-right"
                                        width="150"
                                        height="30"
                                    >
                                        <v-text-field
                                            v-model="item.amount"
                                            :suffix="item.unit"
                                            type="number"
                                            hide-details
                                            dense
                                            solo
                                            @keydown.enter="saveNewIngredient"
                                            @keydown.esc="cancelCreateNewIngredient"
                                        ></v-text-field>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="black"/>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-row
                        class="my-2 mx-5"
                        no-gutters
                    >
                        <v-col
                            class="text-right pa-0"
                        >
                            <v-btn
                                color="#74cf74"
                                class="mt-0 white--text"
                                @click.prevent="saveNewIngredient"
                                :disabled="disableCreateIngredient"
                            >
                                Create Ingredient
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="errorMessage != null"
                        no-gutters
                    >
                        <v-col
                            class="text-right mt-1 pt-0 mx-5 red--text caption"
                        >
                            {{errorMessage}}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>

    export default {
        components: {
            
        },

        mounted() {
            
        },

        data: () => ({
            errorMessage: null,
            newIngredientName: null,
            newIngredientPlural: null,
            newIngredientUnitQuantity: null,
            storeSection: null,
            storeSections: [
                'Bakery'
                ,'Baking'
                ,'Condiments'
                ,'Dairy'
                ,'Frozen Foods'
                ,'Grocery'
                ,'Lunch Meat/Cheese'
                ,'Meat/Seafood'
                ,'Produce'
                ,'Snacks'
                ,'Spices'
            ],
            newIngredientUnit: null,
            allergy: [],
            nutrition: [
                {
                    category: 'Total Fat',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-0',
                    fontWeight: 'font-weight-bold'
                },
                {
                    category: 'Saturated Fat',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-4',
                    fontWeight: 'font-weight-regular'
                },
                {
                    category: 'Trans Fat',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-4',
                    fontWeight: 'font-weight-regular'
                },
                {
                    category: 'Polyunsaturated Fat',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-4',
                    fontWeight: 'font-weight-regular'
                },
                {
                    category: 'Monounsaturated Fat',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-4',
                    fontWeight: 'font-weight-regular'
                },
                {
                    category: 'Cholesterol',
                    amount: null,
                    unit: 'mg',
                    ml: 'ml-0',
                    fontWeight: 'font-weight-bold'
                },
                {
                    category: 'Sodium',
                    amount: null,
                    unit: 'mg',
                    ml: 'ml-0',
                    fontWeight: 'font-weight-bold'
                },
                {
                    category: 'Total Carbohydrate',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-0',
                    fontWeight: 'font-weight-bold'
                },
                {
                    category: 'Dietary Fiber',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-4',
                    fontWeight: 'font-weight-regular'
                },
                {
                    category: 'Sugars',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-4',
                    fontWeight: 'font-weight-regular'
                },
                {
                    category: 'Protein',
                    amount: null,
                    unit: 'g',
                    ml: 'ml-0',
                    fontWeight: 'font-weight-bold'
                },
            ],
        }),

        methods: {
            saveNewIngredient(){
                this.errorMessage = null;
                let duplicateCheck = 0;
                let max = this.ingredients.length;

                for (let i=0; i < max; i++){
                    if (this.ingredients[i].name.toLowerCase() == this.newIngredientName.toLowerCase()){
                        duplicateCheck += 1;
                    }
                }

                if (duplicateCheck == 0){
                    if (!this.disableCreateIngredient) {
                        this.$store.dispatch('data/saveNewIngredient',
                            {
                                name: this.newIngredientName,
                                plural: this.newIngredientPlural,
                                storeSection: this.storeSection,
                                measurementUnit: this.newIngredientUnit,
                                gramsTotalFat: (this.nutrition[0].amount/this.newIngredientUnitQuantity),
                                gramsSaturatedFat: (this.nutrition[1].amount/this.newIngredientUnitQuantity),
                                gramsTransFat: (this.nutrition[2].amount/this.newIngredientUnitQuantity),
                                gramsPolyunsaturatedFat: (this.nutrition[3].amount/this.newIngredientUnitQuantity),
                                gramsMonounsaturatedFat: (this.nutrition[4].amount/this.newIngredientUnitQuantity),
                                milligramsCholesterol: (this.nutrition[5].amount/this.newIngredientUnitQuantity),
                                milligramsSodium: (this.nutrition[6].amount/this.newIngredientUnitQuantity),
                                gramsTotalCarbohydrate: (this.nutrition[7].amount/this.newIngredientUnitQuantity),
                                gramsDietaryFiber: (this.nutrition[8].amount/this.newIngredientUnitQuantity),
                                gramsSugars: (this.nutrition[9].amount/this.newIngredientUnitQuantity),
                                gramsProtein: (this.nutrition[10].amount/this.newIngredientUnitQuantity),
                                allergy: this.allergy,
                                route: this.currentRoute,
                            }
                        );
                        this.clearCreateIngredientData();
                    }
                } else {
                    this.errorMessage = 'Another ingredient already exists named "';
                    this.errorMessage += this.newIngredientName;
                    this.errorMessage += '"';
                }
            },
            cancelCreateNewIngredient () {
                this.addIngredient = false;
                this.createNewIngredientDialog = false;
                this.amount = null;
                this.units = null;
                this.ingredientToAdd = null;
                //this.preparation = null;
                this.clearCreateIngredientData();
            },
            clearCreateIngredientData() {
                this.newIngredientName = null;
                this.newIngredientPlural = null;
                this.newIngredientUnit = null;
                this.storeSection = null;
                this.newIngredientUnitQuantity = null;
                this.newIngredientUnit = null;
                this.allergy = [];
                this.nutrition[0].amount = null;
                this.nutrition[1].amount = null;
                this.nutrition[2].amount = null;
                this.nutrition[3].amount = null;
                this.nutrition[4].amount = null;
                this.nutrition[5].amount = null;
                this.nutrition[6].amount = null;
                this.nutrition[7].amount = null;
                this.nutrition[8].amount = null;
                this.nutrition[9].amount = null;
                this.nutrition[10].amount = null;
                this.addIngredientDialog = false;
                this.createNewIngredientDialog = false;
            },
            cancelAddIngredient () {                    //------------ make sure this works to cancel adding an ingredient to a recipe
                this.addIngredientDialog = false;
                this.createNewIngredientDialog = false;
                this.amount = null;
                this.units = null;
                this.ingredientToAdd = null;
                this.preparation = null;
                this.clearCreateIngredientData();
            },

        },

        computed: {
            ingredients() {
                return this.$store.getters['data/ingredient'];
            },

            disableCreateIngredient() {
                if(this.newIngredientName == null ||
                    this.newIngredientName == '' ||
                    ((this.newIngredientPlural == null || this.newIngredientPlural == '') && this.newIngredientUnit == 'count') ||
                    this.newIngredientUnit == null ||
                    this.storeSection == null ||
                    this.storeSection == '' ||
                    this.newIngredientUnitQuantity == null ||
                    this.newIngredientUnitQuantity == '' ||
                    this.newIngredientUnit == null ||
                    this.newIngredientUnit == '' ||
                    this.nutrition[0].amount == null ||
                    this.nutrition[0].amount == '' ||
                    this.nutrition[1].amount == null ||
                    this.nutrition[1].amount == '' ||
                    this.nutrition[2].amount == null ||
                    this.nutrition[2].amount == '' ||
                    this.nutrition[3].amount == null ||
                    this.nutrition[3].amount == '' ||
                    this.nutrition[4].amount == null ||
                    this.nutrition[4].amount == '' ||
                    this.nutrition[5].amount == null ||
                    this.nutrition[5].amount == '' ||
                    this.nutrition[6].amount == null ||
                    this.nutrition[6].amount == '' ||
                    this.nutrition[7].amount == null ||
                    this.nutrition[7].amount == '' ||
                    this.nutrition[8].amount == null ||
                    this.nutrition[8].amount == '' ||
                    this.nutrition[9].amount == null ||
                    this.nutrition[9].amount == '' ||
                    this.nutrition[10].amount == null ||
                    this.nutrition[10].amount == ''
                ) {
                    return true
                } else {
                    return false
                }
            },
            ingredientToAdd: { //current ingredient selected to add
                get() {
                    return this.$store.getters['data/ingredientToAdd'];
                },
                set(value) {
                    this.$store.dispatch('data/updateIngredientToAdd',value)
                }
            },
            createNewIngredientDialog: {
                get() {
                    return this.$store.getters['data/createNewIngredientDialog'];
                },
                set(value) {
                    this.$store.dispatch('data/updateCreateNewIngredientDialog',value)
                }
            },
            addIngredientDialog: {
                get() {
                    return this.$store.getters['data/addIngredientDialog'];
                },
                set(value) {
                    this.$store.dispatch('data/updateAddIngredientDialog',value);
                }
            },
            getUnitOptions() {
                return this.$store.getters['data/conversionChart'];
            },

            unitOptionsNew() {
                let list = [];
                let max = this.getUnitOptions.length;

                for (let i = 0; i < max; i++) {
                    list.push(this.getUnitOptions[i].unit)
                }
                return list
            },

            allergies() {
                return this.$store.getters['data/allergies'];
            },

            currentRoute() {
                return this.$route.name;
            }
                
        },
            
    }
</script>